export default __webpack_public_path__ + "static/media/02_DAIF_Services_01_loop.fa305667.mp4";